import { useState, useEffect } from "react";
import { Wrapper } from "./elements";

const ScrollToTop = () => {
  const [yOffset, setyOffset] = useState(window.pageYOffset);

  useEffect(() => {
    const listner = () => setyOffset(window.pageYOffset);
    window.addEventListener("scroll", listner);
    return () => window.removeEventListener("scroll", listner);
  }, [setyOffset]);

  return (
    <Wrapper
      visible={yOffset > 100 ? 1 : 0}
      to="topDiv"
      smooth={true}
      duration={500}
      spy={true}
      exact="true"
    >
      <i className="fas fa-angle-up " />
    </Wrapper>
  );
};

export default ScrollToTop;
